import { render, staticRenderFns } from "./KnProductTaxes.vue?vue&type=template&id=398ab498&"
import script from "./KnProductTaxes.vue?vue&type=script&lang=js&"
export * from "./KnProductTaxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports